import { useParams } from "react-router";
import { ViewDetails } from "./ViewDetails";

export const ViewDetailsRoute: React.FC = () => {
  const { viewId } = useParams<{
    viewId: string;
  }>();

  if (!viewId) {
    return null;
  }

  return <ViewDetails key={viewId} viewId={viewId} />;
  // return <></>;
};
